import type { ChangeEvent, FocusEvent, ReactElement } from "react";
import { memo } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import type { IWebhookTableCellBaseProps } from "../../types/cell-props";
import { StyledWebhookTableCellWrapper } from "../styles";

import { StyledInput } from "./styles";

interface IWebhookInputCellProps extends IWebhookTableCellBaseProps {
    onChange: (val: string, e: ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (val: string, e: FocusEvent<HTMLInputElement>) => void;
}

const InputCell = ({
    value,
    placeholder,
    isDisabled = false,
    error,
    onChange,
    onBlur,
}: IWebhookInputCellProps): ReactElement => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value, event);
    };

    const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
        onBlur?.(value, event);
    };

    return (
        <StyledWebhookTableCellWrapper>
            <Stack>
                <StyledInput
                    data-automation="results-search-field"
                    type="text"
                    value={value}
                    isInvalid={!!error}
                    disabled={isDisabled}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder={placeholder || translate("annotations.textarea.placeholder")}
                />
                {error ? (
                    <Text
                        fontVariant="caption"
                        color={colorsPalettes.red[400]}
                        margin={"0 0 -20px 0"}
                    >
                        {error}
                    </Text>
                ) : null}
            </Stack>
        </StyledWebhookTableCellWrapper>
    );
};

export default memo(InputCell);
